module.exports = __webpack_public_path__ + "static/Mr-Handyman-Logo-optimized-2-99436740a27531f11d998d5a505f5ee5.png";